import { useEffect, useState } from 'react';
import SectionCard from '../components/SectionCard';

function CustomersPage() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const loadUsers = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await fetch('/api/admin/users', {
        method: 'GET',
        credentials: 'include'
      });
      const payload = await response.json();
      if (!response.ok) {
        throw new Error(payload.error || 'Не удалось загрузить пользователей');
      }
      setUsers(Array.isArray(payload) ? payload : []);
    } catch (loadError) {
      setError(loadError.message || 'Не удалось загрузить пользователей');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadUsers();
  }, []);

  const setUserStatus = async (userId, action) => {
    setError('');
    try {
      const response = await fetch(`/api/admin/${action}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({ user_id: userId })
      });
      const payload = await response.json();
      if (!response.ok) {
        throw new Error(payload.error || 'Не удалось обновить статус пользователя');
      }
      await loadUsers();
    } catch (statusError) {
      setError(statusError.message || 'Не удалось обновить статус пользователя');
    }
  };

  return (
    <div className="page-grid">
      <SectionCard title="Пользователи" subtitle="Живые данные пользователей из базы">
        {error ? <p className="offer-error">{error}</p> : null}
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Email</th>
                <th>Роль</th>
                <th>Статус</th>
                <th>Дата регистрации</th>
                <th>Действия</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6">Загрузка...</td>
                </tr>
              ) : users.length === 0 ? (
                <tr>
                  <td colSpan="6">Пользователи не найдены</td>
                </tr>
              ) : (
                users.map((user) => (
                  <tr key={user.id}>
                    <td>{user.id}</td>
                    <td>{user.email}</td>
                    <td>{user.role}</td>
                    <td>{user.status}</td>
                    <td>{user.dataregistr ? new Date(user.dataregistr).toLocaleString() : '-'}</td>
                    <td className="offer-actions-cell">
                      {user.status === 'banned' ? (
                        <button
                          className="offer-action-button"
                          type="button"
                          onClick={() => setUserStatus(user.id, 'unban_user')}
                        >
                          Разбанить
                        </button>
                      ) : (
                        <button
                          className="offer-action-button danger"
                          type="button"
                          onClick={() => setUserStatus(user.id, 'ban_user')}
                        >
                          Забанить
                        </button>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </SectionCard>
    </div>
  );
}

export default CustomersPage;